"use strict";

exports.__esModule = true;
exports.ReactModuleContainerContext = exports.ReactLoadableComponent = exports.ReactLazyComponent = exports.ModuleRegistry = exports.AngularLazyComponent = void 0;

var _moduleRegistry = _interopRequireDefault(require("./module-registry"));

exports.ModuleRegistry = _moduleRegistry["default"];

var _reactLazyComponent = _interopRequireDefault(require("./react-lazy-component"));

exports.ReactLazyComponent = _reactLazyComponent["default"];

var _angularLazyComponent = _interopRequireDefault(require("./angular-lazy-component"));

exports.AngularLazyComponent = _angularLazyComponent["default"];

var _reactLoadableComponent = _interopRequireDefault(require("./react-loadable-component"));

exports.ReactLoadableComponent = _reactLoadableComponent["default"];

var _context = require("./context");

exports.ReactModuleContainerContext = _context.ReactModuleContainerContext;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }